import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Locale, Translation } from 'locale'
import { GridActions } from 'store/grid'
import { GlobalGridSettings, BestPriceType } from 'store/grid/gridTypes'
import { bestPriceTypeSelector } from 'selectors/gridSelectors'
import { Selectbox } from 'view/components/options'
import { BestPriceTypeWrapper } from './toolbarStyles'

interface BestPriceTypeSelectboxProps {
  bestPriceType: BestPriceType
  onSaveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) => unknown
}

const mapStateToProps = createStructuredSelector({
  bestPriceType: bestPriceTypeSelector
})

const mapDispatchToProps = {
  onSaveGlobalGridSettings: GridActions.saveGlobalGridSettings
}

const BestPriceTypeSelectboxComponent: FunctionComponent<BestPriceTypeSelectboxProps> = props => {
  const { onSaveGlobalGridSettings, bestPriceType } = props

  const handleUpdate = (type: BestPriceType) => {
    onSaveGlobalGridSettings({
      bestPriceType: type
    })
  }

  return (
    <BestPriceTypeWrapper>
      <span>{Locale.translate(Translation.TC_BEST_PRICE_CALCULATION)}</span>
      <Selectbox
        optionKeys={[BestPriceType.RATE, BestPriceType.REPO_INTEREST]}
        value={bestPriceType}
        getOption={option =>
          option === BestPriceType.RATE ? Locale.translate(Translation.UC_WAS) : Locale.translate(Translation.TC_REPO_INTEREST)
        }
        onUpdate={handleUpdate}
      />
    </BestPriceTypeWrapper>
  )
}

export const BestPriceTypeSelectbox = connect(mapStateToProps, mapDispatchToProps)(BestPriceTypeSelectboxComponent)
